import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { DELETE_DOCUMENT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class DeleteDocument extends BaseApiRequest {
  method = METHOD.HTTP.DELETE;

  body = {};

  url = DELETE_DOCUMENT_URL;

  constructor(applicationId, documentId) {
    super();
    const paramList = [applicationId, documentId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
